export default __webpack_public_path__ + "static/media/arrows-swap.6e352fac.svg";